import React, {useState} from 'react'
import TalentInterview from "../TalentInterview";
import TalentInterviewSteps from "../video-interview/TalentInterviewSteps";
import TalentAppStep from "../components/TalentAppStep";
import {Link, Navigate} from "react-router-dom";
import ModalVideo from "react-modal-video";


const InterviewReviewPreview = (props) => {

    const [isPreviewing, setIsPreviewing] = useState(false)
    return (
        <React.Fragment>
            <div className="mt-3">
                <div className="flex flex-row gap-6 items-center">
                    <div
                        className="relative inline-flex items-start self-start flex-col bg-gray-200 rounded-lg overflow-hidden">
                        <div className="min-w-52 w-52 relative min-h-[117px] h-[117px]">
                            <video src={props.video.video_path}
                                   controls={false}
                                   width="100%" height="100%"
                                   className="pointer-events-none rounded object-contain"/>
                        </div>

                        <div
                            className="absolute inset-0 bg-black bg-opacity-20 flex flex-col items-center justify-center">
                            <i className="fas fa-play text-white opacity-70 fa-2x clickable"
                               onClick={() => setIsPreviewing(true)}/>
                        </div>
                    </div>

                </div>
            </div>
            <ModalVideo
                channel="custom"
                url={props.video.video_path}
                isOpen={isPreviewing}
                onClose={() => setIsPreviewing(false)}
            />
        </React.Fragment>
    )
}
export default class VideoInterviewStep extends TalentAppStep {


    static path = '/video-interview';
    /**
     * The title shown on the form
     */
    static StepTitle = 'Video Interview';
    /**
     * The subtitle shown on the form
     */
    static StepSubtitle = ' ';
    /**
     * The start page info tile
     */
    static StepInfo = 'i';

    static FullScreenEnabled = true;

    static HasRequirements = true;
    /**
     * The Step Section to be grouped in after application approval
     */
    static StepSection = 'Background';

    /**
     * The step needed before editing
     */
    static StepNeedsValidation(user) {
        return false;
    };

    static getPath(prefix = '/talent/application') {
        return `${prefix}${this.path}`
    }

    /**
     * Hide completion icon on sidebar
     */
    static NeedsCompletion = () => false;

    /**
     * Check if we should prevent application from saving and show alert
     */
    static getValidProps(user) {

        // if(!user.hasCompletedVideoInterview() && !user.isApplicationApproved()) {
        //     TB.toast("All video interview questions are required.", {theme: "danger"});
        //     return false;
        // }

        return {talent_video_interviews: user?.talent_video_interviews || []};
    };

    /**
     * @param {User} user
     * @param {User} auth
     * @returns {Object}
     */
    static reviewMapping(user, auth) {

        let videos = [...(user?.talent_video_interviews || [])];
        let review = {};
        TB.map(videos, (video) => {
            if (video.video_path) {
                review[`Question #${video.step?.display_index}`] = {
                    'Your Submission': [video.step?.question, <InterviewReviewPreview video={video}/>],
                }
            }

        })
        return review
    }

    static hasCompleted(user) {
        return user.hasCompletedVideoInterview()
    }

    /**
     * The fields mapping for the form
     */
    static showFormButtons() {
        return true
    }



    renderSubtitle() {

        let user = this.props.user || {};

        let videosCompleted = user.talent_video_interviews?.length || 0
        return (
            <div className="flex flex-col items-start mb-6">

                {user?.isApplicationApproved() ? (
                    <h5 className="form-subtitle mb-4 flex flex-col gap-2">
                        <span>
                            Below are your video interview submissions to talent questions.
                        </span>
                        <span>
                            This part is <b>optional</b> but will give Wripple a deeper understanding of who you are and
                            how you work. You can also choose to make your videos viewable on your client-facing
                            profile.
                        </span>
                    </h5>
                ) : (
                    <h5 className="form-subtitle mb-4 flex flex-col gap-2">
                        <span>
                            Last step! Please record a short video of yourself answering each interview question below.
                            You can retake videos as many times as you want!
                        </span>
                        <span>
                            This part is <b>optional</b> but will give Wripple a deeper understanding of who you are and
                            how you work. If approved to join Wripple you can also choose to make your videos viewable
                            on your client-facing profile.
                        </span>
                    </h5>
                )}

                <Link to={'setup'}
                      className={TB.mapClass("self-start flex-[unset] btn text-xs py-3.5 mb-0.5 max-w-[200px]", {
                          "btn-primary": !videosCompleted,
                          "btn-dark": videosCompleted > 0
                })}>
                    {videosCompleted > 0 ? "Retake Video Interview" : "Begin Video Interview"}
                </Link>
            </div>
        )
    }

    /**
     * Render the form
     *
     * @returns
     */
    render() {

        // return <Navigate to="/talent/interview"/>

        if (!this.props.isEditingInterviewStep) {
            return (
                <div className="talent-application px-4 md:px-8 xl:w-10/12 w-full mr-auto ml-0">
                    {this.renderTitle()}

                    <div className="px-8 py-6 talent-preferences-panel terms-panel mt-0">
                        <TalentInterviewSteps onChange={this.props.onChange} />
                    </div>

                    {this.renderFormFooter()}
                </div>
            )
        }
        if (!this.props.isEditingInterviewStep) {
            return <Navigate to="setup"/>
        }
        return (
            <TalentInterview
                onChange={this.props.onChange}
                onComplete={async (callback = () => true) => {
                    let didSubmit = await this.props.onSubmit(this.props.user, false, true);
                    if (didSubmit) {
                        return callback();
                    }
                }}/>
        );
    }

    // /**
    //  * Are requirements completed?
    //  *
    //  * @returns boolean
    //  */
    // isRequirementComplete() {
    //     return this.context.auth?.hasCompletedVideoInterview();
    // }
    //
    // /**
    //  * Requirement messaging
    //  *
    //  * @returns string
    //  */
    // requirementInfo() {
    //     return 'All video interview questions are required.';
    // }
    /**
     * Are requirements optional?
     *
     * @returns boolean
     */
    isRequirementOptional() {
        return true;
    }

    /**
     * Requirement messaging
     *
     * @returns string
     */
    requirementInfo() {
        return 'Video interview is optional and not required.';
    }
}